module.exports = __webpack_public_path__ + "img/logwhite.38dce4b5.png";